// Load Bootstrap JS
import bootstrap from 'bootstrap'

// Load Styles
import '../scss/main.scss';

// Demo of using .env variables
// console.log(`Google Maps API Key: ${process.env.GOOGLE_MAPS_API_KEY}`);

import initDesktopNav from "./modules/dektop_nav";
import initHamburg from "./modules/init_hamburg";
import initFixedMenu from "./modules/init_fixed_menu";
import initSlider from "./modules/init_slider";
import initLightbox from "./modules/init_lightbox";
import initAccordion from "./modules/init_accordion";
document.addEventListener("DOMContentLoaded", () => {
  initDesktopNav();
  initHamburg();
  initFixedMenu();
  initSlider();
  initLightbox();
  initAccordion();
});
